// extracted by mini-css-extract-plugin
export default {"cls1":"StickyWorkCardHeader-cls1_H3d","cls2":"StickyWorkCardHeader-cls2_zjD StickyWorkCardHeader-cls1_H3d","hidden":"StickyWorkCardHeader-hidden_A_U"};